import { Outlet } from 'react-router-dom';

function Persons() {
    return (
        <Outlet />
    );
}

export default Persons;